namespace RioERP.Enquiry {
    export interface PendingOrdersForm {
        NopOrderId: Serenity.IntegerEditor;
        OrderDate: Serenity.DateEditor;
        CustomerId: Serenity.LookupEditor;
        CustomerName: Serenity.StringEditor;
        Mobile: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        HandledBy: Serenity.LookupEditor;
        OrderStatus: Serenity.EnumEditor;
        Address: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.LookupEditor;
        Pincode: Serenity.IntegerEditor;
        OrderProducts: Serenity.LookupEditor;
    }

    export class PendingOrdersForm extends Serenity.PrefixedContext {
        static formKey = 'Enquiry.PendingOrders';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PendingOrdersForm.init)  {
                PendingOrdersForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.StringEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(PendingOrdersForm, [
                    'NopOrderId', w0,
                    'OrderDate', w1,
                    'CustomerId', w2,
                    'CustomerName', w3,
                    'Mobile', w3,
                    'Email', w3,
                    'HandledBy', w2,
                    'OrderStatus', w4,
                    'Address', w3,
                    'City', w3,
                    'StateId', w2,
                    'Pincode', w0,
                    'OrderProducts', w2
                ]);
            }
        }
    }
}
